// extracted by mini-css-extract-plugin
export var dataCell = "_me-2";
export var dataRow = "_me-0";
export var headerRow = "_me-1";